<p-table [value]="tests" [paginator]="false" *ngIf="colors">
  <ng-template pTemplate="header">
    <tr>
      <th *ngIf="showAcumuladosSelection" style="width: 2.5rem" id="acumulados-select-column"></th>
      <th id="tecnica-column">{{ "REQUEST_DATA.TEST.TECNICA" | translate }}</th>
      <th id="patologico-column">{{ "REQUEST_DATA.TEST.PATOLOGICO" | translate }}</th>
      <th [ngStyle]="{ width: WIDTH.RESULTADOS }" id="resultados-column">
        {{ "REQUEST_DATA.TEST.RESULTADOS" | translate }}
      </th>
      <th id="unidades-column">{{ "REQUEST_DATA.TEST.UNIDADES" | translate }}</th>
      <th [ngStyle]="{ width: WIDTH.RANGOS }" id="rangos-column">
        {{ "REQUEST_DATA.TEST.RANGOS" | translate }}
      </th>
      <th id="validado-column">{{ "REQUEST_DATA.TEST.VALIDADO" | translate }}</th>
      <th id="previo-column">{{ "REQUEST_DATA.TEST.PREVIO" | translate }}</th>
      <th id="dias-column">{{ "REQUEST_DATA.TEST.DIAS" | translate }}</th>
      <th id="anexos-column">{{ "REQUEST_DATA.TEST.ANEXOS" | translate }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item let-i="index">
    <tr
      *ngIf="!isHeader(item) && !isComment(item)"
      [class.before-comment]="i < tests.length - 1 && isComment(tests[i + 1])"
      [ngStyle]="{color: getIconTypeForP(item).show ? getIconTypeForP(item).color : ''}"
    >
      <td *ngIf="showAcumuladosSelection">
        <p-checkbox
          [binary]="true"
          [ngModel]="isSelectedForAcumulados(item)"
          (onChange)="toggleAcumuladosSelection(item)"
          [inputId]="'acum-' + item.metodo"
        ></p-checkbox>
      </td>
      <td>{{ item.metname }}</td>
      <td>
        <i
          *ngIf="getIconTypeForP(item).show"
          [class]="'pi pi-arrow-' + getIconTypeForP(item).direction"
          [ngStyle]="{
            'font-size': '0.9rem',
            'font-weight': 'bold',
            color: getIconTypeForP(item).color
          }"
        ></i>
      </td>
      <td [ngStyle]="{ width: WIDTH.RESULTADOS }" [innerHTML]="item.resultado"></td>
      <td>{{ item.unidades }}</td>
      <td [ngStyle]="{ width: WIDTH.RANGOS }">{{ item.rangos }}</td>
      <td>{{ item.valid }}</td>
      <td>{{ item.res_Prev }}</td>
      <td>{{ item.dias }}</td>
      <td>{{ "------" }}</td>
    </tr>
    <tr *ngIf="isHeader(item)" [className]="'header-' + item.restyp">
      <td *ngIf="showAcumuladosSelection"></td>
      <td [attr.colspan]="showAcumuladosSelection ? 9 : 9">
        {{ item.metname }}
      </td>
    </tr>
    <tr *ngIf="isComment(item)" [className]="'comment'">
      <td *ngIf="showAcumuladosSelection"></td>
      <td></td>
      <td [attr.colspan]="showAcumuladosSelection ? 8 : 8" [innerHTML]="item.resultado"></td>
    </tr>
  </ng-template>
</p-table>
